import React from 'react';
import TablaVotosPartidos_FilaCandidatoVotos from './TablaVotosPartidos_FilaCandidatoVotos';
import TablaVotosPartidos_FilaCandidatoCargo from './TablaVotosPartidos_FilaCandidatoCargo';
import styled from 'styled-components/macro';

const TablaVotosPartidos_FilaCandidato = ({ data, eleccion, mostrarCargos }) => {
  const showVotosCandidato = candidato => {
    if (candidato.pref === '1') {
      return true;
    } else if (candidato.pref === '0' && candidato.codcan === '0') {
      return true;
    } else {
      return false;
    }
  };

  let mostrarVotos = showVotosCandidato(data);
  if (eleccion === '1' || eleccion === '6' || eleccion === '8' || eleccion === '9') mostrarVotos = false;
  let Span = mostrarVotos ? 1 : 3;
  Span = mostrarCargos ? Span : Span + 1;

  return (
    <tr className="candidato">
      <CandidatoTd colSpan={Span}>
        <span>{data.nomcan + ' ' + data.apecan}</span>
        <span>{data.nomcan2 + ' ' + data.apecan2}</span>
      </CandidatoTd>
      {mostrarVotos && <TablaVotosPartidos_FilaCandidatoVotos data={data} />}
      {mostrarCargos && <TablaVotosPartidos_FilaCandidatoCargo data={data} />}
    </tr>
  );
};

const CandidatoTd = styled.td`
  display:flex;
  flex-direction:column;
`

export default TablaVotosPartidos_FilaCandidato;
